import { isFulfilled } from '@reduxjs/toolkit'
import { hasError } from '@repo/shared/api/helpers'
import { Button } from '@repo/ui/button'
import { Card, CardAction, CardDescription, CardHeader, CardTitle } from '@repo/ui/card'
import { CardContent } from '@repo/ui/card'
import { useT } from '@repo/ui/hooks'
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import Form from '@/components/admin/insights/edit/Form'
import { FormHandle, InsightsWidgetForm } from '@/components/admin/insights/edit/types'
import { beneficiaryInsightsActions as actions } from '@/store/beneficiary-insights/slice'
import { useStoreDispatch } from '@/store/hooks'

import { buildSearchParam, SearchParamsKeyNames, SearchParamsViewNames } from '..'

export function InsightsNewRoute() {
  const dispatch = useStoreDispatch()
  const navigate = useNavigate()
  const { t } = useT({ keyPrefix: 'admin.insights.new' })
  const formRef = useRef<FormHandle>(null)

  useEffect(() => {
    void dispatch(actions.reset())
  }, [])

  const createNewWidget = (widget: InsightsWidgetForm) => {
    void dispatch(actions.addInsightWidget(widget)).then((res) => {
      if (hasError(res) || !isFulfilled(res)) return
      navigate(
        buildSearchParam(SearchParamsKeyNames.View, SearchParamsViewNames.INSIGHTS_EDIT, {
          id: res.payload?.id,
        }),
      )
    })
  }

  return (
    <>
      <Card className="flex flex-1 flex-col overflow-hidden bg-opacity-20">
        <CardHeader>
          <CardTitle>{t('title')}</CardTitle>
          <CardDescription>{t('description')}</CardDescription>
          <CardAction>
            <Button onClick={() => formRef.current?.submit()}>{t('create')}</Button>
          </CardAction>
        </CardHeader>
        <CardContent className="flex flex-1 flex-col gap-4 h-full overflow-y-auto">
          <Form
            widget={null}
            ref={formRef}
            onValidityChange={() => {}}
            onSubmit={createNewWidget}
          />
        </CardContent>
      </Card>
    </>
  )
}
